import { TenantProvider } from "@/context/TenantContext";
import MainLayout from "@/layouts/MainLayout";
import StarterLayout from "@/layouts/StarterLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import ServiceDeskApp from "./projects/Service-Desk/app";
import "./projects/Service-Desk/styles/style.css";
import routes from "@/utils/routes";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";

function App() {
  return (
    <TenantProvider>
      <AppWithRouter />
    </TenantProvider>
  );
}

const AppWithRouter = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<TopLevelComponent />}>
          {/* Frontend design mode — no tenant, no auth */}
          <Route index element={<Navigate to="/sd" replace />} />
          <Route
            path="sd/*"
            element={
              <div className="service-desk-root">
                <ServiceDeskApp />
              </div>
            }
          />

          {publicRoutes.map(({ path, element: Page }) => (
            <Route key={path} path={path} element={<StarterLayout />}>
              <Route index element={<Page />} />
            </Route>
          ))}

          <Route element={<MainLayout />}>
            {authRoutes.map(({ path, element: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const TopLevelComponent = () => {
  return <Outlet />;
};

export default App;
